export default { title: 'appliance_type', component: 'appliance_type' };
